<template>
  <div class="xianmgqing">
    <!-- banner -->
    <div class="banner">
      <img src="../../../assets/images/dongtai/banner.png" alt="" />
    </div>
    <!-- 内容 -->
    <div class="xiangxi">
      <div class="fuwenben" v-for="(item, index) in nierongList" :key="index">
        <p class="title1">{{ item.Extend1 }}</p>
        <p class="shijian">
          {{ item.Extend8 != null ? item.Extend8.split("T")[0] : "" }}
        </p>
        <div class="survey" v-html="item.InfoHtmlBody"></div>
        <div class="fanye">
          <div class="upAndDown">
            <div class="Part" @click="Previous(PreviousPage)">
              <div class="feilb">
                <p>上一篇 ></p>
              </div>
              <div class="feilb1">
                <p>
                  {{
                    PreviousPage != null ? PreviousPage.Extend1 : "暂无上一篇"
                  }}
                </p>
              </div>
            </div>
            <div class="Next" @click="Npage(NextPage)">
              <div class="feilb1">
                <p>{{ NextPage != null ? NextPage.Extend1 : "暂无下一篇" }}</p>
              </div>
              <div class="feilb">
                <p>下一篇></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="biaodsn">
      <p class="biao">百才汇——专业、值得信赖的上海落户服务</p>
      <div class="inp">
        <input type="text" v-model="name" placeholder="您的姓名" />
      </div>
      <div class="inp">
        <input type="text" v-model="tel" placeholder="联系方式" />
      </div>
      <div class="istextarea">
        <textarea
          v-model="textarea"
          cols="30"
          rows="4"
          placeholder="你的留言"
        ></textarea>
      </div>
      <button class="btn1" @click="registerOne">立即预约</button>
    </div>
    <!-- 常见问答 -->
    <div class="wenda">
      <p class="title">常见问答</p>
      <ul>
        <li
          v-for="(item, index) in wendaList"
          :key="index"
          @click="handlewendaClick(item)"
        >
          <img src="../../../assets/images/dongtai/dian.png" alt="" />
          <p>{{ item.Extend1 }}</p>
        </li>
      </ul>
    </div>
    <!-- 热点资讯 -->
    <div class="zixun">
      <p class="title">热点资讯</p>
      <ul>
        <li
          v-for="(item, index) in redianList"
          :key="index"
          @click="redianClick(item)"
        >
          <div class="isImg">
            <img :src="imgUrl + item.Extend3" alt />
          </div>
          <p>{{ item.Extend1 }}</p>
        </li>
      </ul>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Bottom from "@/P09_BaiCaiHui/components/Foot.vue";
import Vue from "vue";
import { Notify } from "vant";
export default {
  components: {
    Bottom,
  },
  metaInfo() {
    return {
      title: `${this.title}-百才汇`,
      meta: [
        {
          name: "keywords",
          content: `${this.keywords}`,
        },
        {
          name: "description",
          content: `${this.description}`,
        },
      ],
    };
  },
  data() {
    return {
      wendaList: [],
      redianList: [],
      imgUrl: "",
      title: "",
      keywords: "",
      description: "",
      NextPage: {},
      PreviousPage: {},
      nierongList: null,
      name: "",
      tel: "",
      textarea: "",
    };
  },
  created() {
    this.getList();
    this.wendaData();
    this.redianData();
  },
  methods: {
    //初始化
    async getList() {
      try {
        let { data: xiangxiInfo } = await this.$axios.post(
          "/trip/TokenPass/GetHantengPublishMenuContent",
          {
            IsNeedPaging: 1,
            WebsiteMenuId: 329,
            WebsiteContentId: this.$route.params.id,
          }
        );
        this.NextPage = xiangxiInfo.Data.NextPage;
        this.PreviousPage = xiangxiInfo.Data.PreviousPage;
        this.nierongList = xiangxiInfo.Data.list;
        // this.title = xiangxiInfo.Data.list[0].Extend1;
        this.title = this.nierongList[0].Extend1;
        this.keywords = this.nierongList[0].Extend1;
        this.description = this.nierongList[0].InfoHtmlBody.replace(
          /<[^>]+>/g,
          ""
        ).substring(0, 50);
      } catch (error) {
        console.error(error);
      }
    },
    //上一篇
    Previous(MenuContentId) {
      if (MenuContentId != null) {
        this.$axios
          .post("/trip/TokenPass/GetHantengPublishMenuContent", {
            WebsiteContentId: MenuContentId.WebsiteContentId,
            WebsiteMenuId: 329,
            IsNeedPaging: 1,
          })
          .then((res) => {
            if (res.data.Code == 200) {
              window.scrollTo(0, 0);
              this.nierongList = [];
              this.NextPage = {};
              this.PreviousPage = {};
              let WebsiteMenuId = "";
              let WebsiteContentId = "";
              this.title = "";
              this.keywords = "";
              this.description = "";
              this.nierongList = res.data.Data.list;
              this.title = this.nierongList[0].Extend1;
              this.keywords = this.nierongList[0].Extend1;
              this.description = this.nierongList[0].InfoHtmlBody.replace(
                /<[^>]+>/g,
                ""
              ).substring(0, 50);
              this.nierongList.forEach((el) => {
                WebsiteMenuId = el.WebsiteMenuId;
                WebsiteContentId = el.WebsiteContentId;
              });
              this.NextPage = res.data.Data.NextPage;
              this.PreviousPage = res.data.Data.PreviousPage;
              this.$router.push(
                "/luohuxiangqing/" + WebsiteContentId + ".html"
              );
            }
          });
      } else {
        Notify({ type: "warning", message: "没有上一篇了哦" });
      }
    },
    //下一篇
    Npage(MenuContentId) {
      if (MenuContentId != null) {
        this.$axios
          .post("/trip/TokenPass/GetHantengPublishMenuContent", {
            WebsiteContentId: MenuContentId.WebsiteContentId,
            WebsiteMenuId: 329,
            IsNeedPaging: 1,
          })
          .then((res) => {
            if (res.data.Code == 200) {
              window.scrollTo(0, 0);
              let WebsiteMenuId = "";
              let WebsiteContentId = "";
              this.title = "";
              this.keywords = "";
              this.description = "";
              this.nierongList = res.data.Data.list;
              this.title = this.nierongList[0].Extend1;
              this.keywords = this.nierongList[0].Extend1;
              this.description = this.nierongList[0].InfoHtmlBody.replace(
                /<[^>]+>/g,
                ""
              ).substring(0, 50);
              this.nierongList.forEach((el) => {
                WebsiteMenuId = el.WebsiteMenuId;
                WebsiteContentId = el.WebsiteContentId;
              });
              this.NextPage = {};
              this.NextPage = res.data.Data.NextPage;
              this.PreviousPage = {};
              this.PreviousPage = res.data.Data.PreviousPage;
              this.$router.push(
                "/luohuxiangqing/" + WebsiteContentId + ".html"
              );
            }
          });
      } else {
        Notify({ type: "warning", message: "没有下一篇了哦" });
      }
    },
    // 表单提交
    registerOne() {
      if (!this.name) {
        Notify({ type: "danger", message: "请输入您的姓名" });
        return false;
      }
      if (!this.tel) {
        Notify({ type: "danger", message: "请输入正确联系方式" });
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: this.name, //姓名
          C01_Tel: this.tel, //联系方式
          C01_Origin: 193, //信息来源
          C01_Message: this.textarea, //留言
        })
        .then((res) => {
          if (res.data.Code == 200) {
            Notify({ type: "success", message: "报名成功" });
            this.name = "";
            this.tel = "";
            this.textarea = "";
          } else if (res.data.Code == 400) {
            Notify({ type: "success", message: res.data.Message });
          } else {
            Notify({ type: "success", message: res.data.Message });
          }
        });
    },
    //初始化问答列表
    wendaData() {
      this.jzTxt = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 330,
          index: 1,
          size: 5,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.wendaList = res.data.Data.list;
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    //点击问答列表点击进入详情页
    handlewendaClick(item, index) {
      // if (item.InfoUrl === "/wendacontent") {
      this.$router.push(
        "/wendacontent/" +
          item.WebsiteContentId +
          "-" +
          item.WebsiteMenuId +
          ".html"
      );
      // } else {
      // window.location.href = item.InfoUrl;
      // }
    },
    //初始化热点列表
    redianData(ispull) {
      this.$axios
        .post("/trip/TokenPass/GetHantengPublishMenuContent", {
          WebsiteMenuId: 329,
          index: 1,
          IsRecommend: 1,
          size: 4,
        })
        .then((res) => {
          if ((res.data.Code = 200)) {
            this.redianList = res.data.Data.list;
            this.imgUrl = res.data.Data.ImageServiceDoMain;
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    // 点击热点跳转
    redianClick(item) {
      window.scrollTo(0, 0);
      this.$router.push("/luohuxiangqing/" + item.WebsiteContentId + ".html");
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.xianmgqing {
  margin-top: 80px;
  //   banner
  .banner {
    width: 100%;
    height: 200px;
    margin-bottom: 60px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  //   内容
  .xiangxi {
    width: 100%;
    padding: 0px 40px;
    box-sizing: border-box;
    .fuwenben {
      .title1 {
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: 700;
        color: #333333;
        line-height: 34px;
      }
      .shijian {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #cecece;
        margin-top: 20px;
        margin-bottom: 40px;
      }
      .survey {
        // font-size: 22px;
        // font-family: Source Han Sans CN;
        // font-weight: 400;
        // color: #555555;
        // line-height: 34px;
        /deep/img {
          max-width: 100%;
        }
      }
      .fanye {
        width: 670px;
        margin: auto;
        margin-top: 60px;
        .upAndDown {
          display: flex;
          justify-content: space-between;
          .Part {
            padding: 0px;
            background: #ffffff;
            border: 1px solid #f1f1f1;
            padding: 60px 25px 0px;
            box-sizing: border-box;
            width: 335px;
            height: 130px;
            position: relative;
            .feilb {
              position: absolute;
              left: 26px;
              top: 21px;
              p:first-child {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #6e6e6e;
              }
            }
            .feilb1 {
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 30px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #6e6e6e;
                line-height: 27px;
              }
            }
          }
          .Next {
            background: #ffffff;
            border: 1px solid #f1f1f1;
            width: 335px;
            height: 130px;
            position: relative;
            padding: 60px 25px 0px;
            box-sizing: border-box;
            .feilb {
              position: absolute;
              left: 26px;
              top: 21px;
              p:first-child {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #6e6e6e;
              }
            }
            .feilb1 {
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: 27px;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #6e6e6e;
              }
            }
          }
        }
      }
    }
  }
  //   表单
  .biaodsn {
    width: 576px;
    height: 520px;
    margin: auto;
    margin-top: 60px;
    background: url("../../../assets/images/dongtai/biaodan-bj.png") no-repeat
      center/cover;
    padding-top: 38px;
    margin-bottom: 50px;
    box-sizing: border-box;
    .biao {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #aa8756;
      text-align: center;
      margin-bottom: 40px;
    }
    .inp {
      width: 418px;
      height: 58px;
      background: rgba(255, 255, 255, 0.17);
      border: 1px solid #eeeeee;
      border-radius: 10px;
      margin: 0 auto;
      overflow: hidden;
      font-size: 18px;
      position: relative;
      margin-bottom: 40px;
      input {
        background: #ffffff;
        display: block;
        border: 0;
        outline: none;
        height: 100%;
        width: 100%;
        padding-left: 40px;
        background: url("../../../assets/images/red.png") no-repeat 10px;
        background-size: 12px;
      }
    }
    .istextarea {
      width: 418px;
      height: 92px;
      margin: auto;
      background: rgba(255, 255, 255, 0.17);
      border: 1px solid #eeeeee;
      border-radius: 10px;
      margin-bottom: 40px;
      textarea {
        padding-left: 30px;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.17);
        border: 1px solid #eeeeee;
        border-radius: 10px;
      }
    }
    .btn1 {
      width: 160px;
      height: 40px;
      background: #e8bc7e;
      border-radius: 20px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      display: block;
      margin: auto;
    }
  }
  //   常见问答
  .wenda {
    width: 670px;
    height: 435px;
    margin: auto;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-top: 1px solid #d8c294;
    padding: 40px 40px 0px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .title {
      font-size: 26px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 40px;
    }
    ul {
      li {
        display: flex;
        margin-bottom: 30px;
        img {
          width: 8px;
          height: 8px;
          margin-top: 8px;
          margin-right: 20px;
        }
        p {
          font-size: 22px;
          font-weight: 400;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  //   热点资讯
  .zixun {
    width: 670px;
    height: 691px;
    margin: auto;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-top: 1px solid #d8c294;
    padding: 42px 42px 0px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .title {
      font-size: 36px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 40px;
    }
    ul {
      li {
        height: 98px;
        display: flex;
        margin-bottom: 40px;
        .isImg {
          width: 168px;
          height: 98px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          width: 410px;
          height: 60px;
          font-size: 22px;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          // text-overflow: -o-ellipsis-lastline; /*两行后超出省略*/
          overflow: hidden;
          text-overflow: ellipsis; /*超出则...代替*/
          display: -webkit-box;
          -webkit-line-clamp: 2; /* 行数*/
          line-clamp: 2; /*行数*/
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>